export default __webpack_public_path__ + "static/media/logo-usdpi-border-white.a17d51b2.svg";